<div *ngIf="step == 'login'">
  <div class="form-group">
    <a href='javascript:;' (click)='loginFacebook()'><button type="button" class="btn btn-primary btn-lg btn-block"><i class="fa fa-facebook"></i> Continuar com Facebook</button></a>
  </div>

  <div class="form-group">
    <a (click)="salvarParametros()" href="http://reachr-login-linkedin.herokuapp.com?client_id=77hxwubktxlv3r&client_secret=iuA4Z8fwlaJR9Yue" ><button type="button" class="btn btn-info btn-lg btn-block"><i class="fa fa-linkedin"></i> Continuar com Linkedln</button></a>
  </div>

  <div class="form-group">
    <hr data-content="OU" class="hr-text">
  </div>

  <form class="signup" (ngSubmit)="newLogin(formdata)" [formGroup]="formdata" method="post" novalidate>
    <div class="form-group">
      <label for="userName">E-mail</label>
      <input class="form-control" formControlName="userName" name="userName" placeholder="Email" required type="email">
      <div *ngIf="userName.errors && (userName.dirty || userName.touched)" class="text-danger">
        <p *ngIf="userName.errors.required">Insira o email</p>
        <p *ngIf="userName.errors.pattern">Verifique seu email</p>
      </div>
    </div>
    <div class="form-group">
      <label for="password">Senha</label>
      <input class="form-control" formControlName="password" name="password" placeholder="Senha" required type="password">
      <div *ngIf="password.errors && (password.dirty || password.touched)" class="text-danger">
        <p *ngIf="password.errors.required">Insira sua senha</p>
        <p *ngIf="password.errors.minlength">Mínimo 6 caracteres</p>
      </div>
    </div>

    <div class="form-group">
      <p>
        <a href="javascript:void(0)" [routerLink]="[]" (click)="abrirFormularioEsqueceuSenha()">Esqueci minha senha.</a>
      </p>
    </div>

    <div class="alert alert-danger" *ngIf="showLoginSenhaIncorreta">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Sua conta ou senha está incorreta.
    </div>

    <div class="alert alert-danger" *ngIf="showLoginNaoConfirmado">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Seu endereço de e-mail ainda não foi confirmado, acesse seu e-mail e confirme sua conta no e-mail recebido da Reachr!
    </div>

    <div class="form-group">
      <input type="submit" class="btn btn-success btn-block" value="Entrar" [disabled]="userName == null || password == null || formdata.invalid">
    </div>
    <p class="cadastrar" *ngIf="mostrarLinkCadastro == true">
      Não possui uma conta?
      <a href="{{siteUrl}}/cadastrar" *ngIf="conta == 'empresa' && nextjobtoken == ''"><b>Cadastre se aqui.</b></a>
      <a href="{{siteUrl}}/cadastrar?nextjobtoken={{nextjobtoken}}" *ngIf="conta == 'empresa' && nextjobtoken != ''"><b>Cadastre se aqui.</b></a>

      <a href="{{siteUrl}}/paracandidatos/cadastrar" *ngIf="conta == 'candidato' && nextjobvagaid == ''"><b>Cadastre se aqui.</b></a>
      <a href="{{siteUrl}}/paracandidatos/cadastrar?nextjobvagaid={{nextjobvagaid}}" *ngIf="conta == 'candidato' && nextjobvagaid != ''"><b>Cadastre se aqui.</b></a>
    </p>
  </form>
</div>

<div *ngIf="step == 'forgot'">
  <h4>Recuperar senha</h4>
  <div class="alert alert-success" *ngIf="forgotSuccess">
    <i class="fa fa-check-square-o" aria-hidden="true"></i> Enviamos um link para seu e-mail. Lá você poderá escolher uma nova senha.
  </div>

  <form [formGroup]="formdata">
    <div class="form-group">
      <label for="forgot-email">E-mail:</label>
      <input class="form-control" formControlName="userName" name="userName" placeholder="Email" required type="email">
      <div *ngIf="userName.errors && (userName.dirty || userName.touched)" class="text-danger">
        <p *ngIf="userName.errors.required">Insira o email</p>
        <p *ngIf="userName.errors.pattern">Verifique seu email</p>
      </div>
    </div>

    <div class="form-group">
      <p>
        <a href="javascript:void(0)" [routerLink]="[]"  (click)="abrirFormularioLogin()">Voltar</a>
      </p>
    </div>

    <button class="btn btn-success btn-block" (click)="solicitarNovaSenha()" [disabled]="userName.errors != null">
      Recuperar senha
    </button>

  </form>
</div>